export const USERS = 'users'
export const USER_STATUS = 'user-status'
export const USER_ROLES = 'user-roles'
export const ADMINS = 'admins'
export const USERS_ADMIN = 'users-admin'
export const USER_INVITES = 'user-invites'
export const USER_SETTINGS = 'user-settings'
export const USERS_DELETED = 'users-deleted'
export const USER_INVITES_DELETED = 'user-invites-deleted'
export const USERS_ADMIN_DELETED = 'users-admin-deleted'
export const USER_ROLES_DELETED = 'user-roles-deleted'
export const ELECTRONIC_CONSENT_AGREEMENTS = 'electronicConsentAgreements'
export const PRACTICE_CONTRACT_AGREEMENTS = 'practiceContractAgreements'
export const ENCOUNTERS = 'encounters'
export const LABS = 'labs'

export const MIDWIVES = 'midwives'
export const MIDWIVES_ADMIN = 'midwives-admin'
export const PRACTICES = 'practices'
export const PRACTICE_ACCESS = 'practice-access'

export const ASSESSMENTS = 'assessments'
export const ASSESSMENTS_ADMIN = 'assessments-admin'
export const ASSESSMENT_SNIPPETS = 'assessment-snippets'

export const ASSESSMENTS_DELETED = 'assessments-deleted'
export const ASSESSMENTS_ADMIN_DELETED = 'assessments-admin-deleted'
export const ASSESSMENT_SNIPPETS_DELETED = 'assessment-snippets-deleted'

export const LABOR_CHARTING = 'labor-charting'

export const PAYMENTS_LOG = 'payments-log'
export const ASSESSMENT_INVOICE_SNIPPETS = 'assessment-invoices'
export const ASSESSMENT_THREADS = 'assessment-threads'
export const PATIENT_THREADS = 'patient-threads'
export const ASSESSMENT_THREADS_ARCHIVED = 'assessment-threads-archived'
export const MESSAGES = 'messages'
export const PRACTICE_THREADS = 'practice-threads'
export const GROUP_THREADS = 'group-threads'
export const DELETED_THREADS = 'deleted-threads'
export const DIRECT_MESSAGE_THREADS = 'direct-message-threads'
export const SETTINGS = 'settings'

export const CLAIMS = 'claims'
export const CLAIMS_ABILITY = 'claims-ability'
export const CLAIMS_ABILITY_DETAIL = 'claims-ability-detail'
export const CLAIMS_DELETED = 'claims-deleted'
export const INVOICES = 'invoices'
export const INVOICES_DELETED = 'invoices-deleted'
export const INVOICING_SETTINGS = 'invoicing-settings'

export const APPOINTMENTS = 'appointments'
export const CONSENT_FORMS = 'consent-forms'
export const DOCUMENTS = 'documents'
export const CONSENT_FORM_TEMPLATES = 'consentFormTemplates'
export const PRACTICE_CONTRACTS = 'practice-contracts'
export const PRACTICE_CONTRACT_TEMPLATES = 'practiceContractTemplates'
// export const PATIENT_CONSENT_FORMS_STATUS = 'patientConsentFormsStatus'
export const VISITS = 'visits'
export const VISIT_DRAFTS = 'visit-drafts'

export const ADMIN_MIDWIVES_DATA = 'midwives-admin'
export const ADMIN_USERS_DATA = 'users-admin'
export const INSURANCE_PROVIDERS = 'insurance-providers'

export const THREADS = 'threads'
export const MESSAGING_WIDGET = 'messaging-widget'

// GYN
export const GYN_INTAKE_CODES = 'gyn-intake-codes'

// DEVOPS
export const BUG_REPORTS = 'bug-reports'
export const SITE_ERRORS = 'site-errors'
// Migration ledger — one doc per migration id, written ONLY by the CD migration runner
// via the Admin SDK (firebase/migrations); no client write path exists.
export const MIGRATIONS = 'migrations'

// AI Features / Charting Settings
export const PREGNANCY_CLINICAL_RATIONALES = 'pregnancyClinicalRationales'
export const ICD_CODE_LIBRARY = 'icdCodeLibrary'
export const TIME_LOG_CONFIG = 'timeLogConfig'
// §6.7: CDI keyword library — admin-configurable, no code deploy required.
export const SUPPLY_KEYWORDS = 'supplyKeywords'
// §6.6: Revenue code registry — admin-configurable UB-04 revenue codes for facility claim billing.
export const REVENUE_CODES = 'revenueCodes'

// Charting config
export const SCOPE_OF_PRACTICE_STATEMENT = 'scopeOfPracticeStatement'
// Per-user charting form preferences (doc id = user id; owner-only read/write).
export const CHARTING_FORM_SETTINGS = 'charting-form-settings'

// Reports
export const PRACTICE_STAGE_REPORTS = 'practice-stage-reports'
export const PRACTICE_CLAIMS_REPORTS = 'practice-claims-reports'

// §2.17: Telephone Contact Log
export const TELEPHONE_CONTACTS = 'telephone-contacts'

// §2.7.1: Lab Results
export const LAB_RESULTS = 'lab-results'

// §2.15.5: PDF export audit trail
export const PDF_EXPORT_LOG = 'pdf-export-log'

// §6.4.2: Billing alerts written by the daily notification scheduler.
export const BILLING_ALERTS = 'billing-alerts'

// §7.1: Append-only audit log of PHI-access events — note views today, exports/prints
// later (each doc carries an `action` field so future event types share the collection
// without a rename). Written ONLY by callables via the Admin SDK; no client read or
// write path exists (see firebase/firestore/.rules) — this is what makes the log
// tamper-evident.
export const AUDIT_LOGS = 'auditLogs'

// §0.5.6 Provider-created and system-generated red text flags (sub-collection on assessment)
export const PROVIDER_FLAGS = 'provider-flags'

// §0.5.8 Provider color dot tag assignments per patient — stored on assessment doc field
// (no separate collection needed — stored as colorTagsByProvider on assessment document)

// §0.5.4 ACNM lab flagging thresholds — stored as settings/{LAB_FLAGGING_THRESHOLDS_DOC}
// Document id defined in labFlaggingThresholds.ts as LAB_FLAGGING_THRESHOLDS_DOC

// §J (Addendum June 2026): GBS GA window config — stored as settings/gbsConfig
// Document id also exported as GBS_CONFIG_DOC from @hb/shared (gbsConfig.ts)
export const GBS_CONFIG_DOC = 'gbsConfig'

// Maintenance banner/page config — stored as settings/maintenance (publicly readable;
// signed-out visitors must see the maintenance page). Written by the CD pipeline via
// the Admin SDK or by super admins. Absent doc = no maintenance.
export const MAINTENANCE_DOC = 'maintenance'

// §C (Addendum June 2026): GA-triggered education checklist collections
export const EDUCATION_CHECKLIST_LOCKED_ITEMS = 'education-checklist-locked-items'
export const EDUCATION_CHECKLIST_GLOBAL_ITEMS = 'education-checklist-global-items'
// Subcollection name shared by practice (midwives/{practiceId}/...) and personal (users-admin/{userId}/...)
export const EDUCATION_CHECKLIST_ITEMS = 'education-checklist-items'

// §I Gap 1 (Addendum June 2026): Patient written statements — immutable once submitted.
export const PATIENT_STATEMENTS = 'patient-statements'

// §E (Addendum June 2026): Dot phrase template expansion system
// Top-level HB global templates; also used as subcollection name for practice and personal levels:
//   practice-level: midwives/{practiceId}/dot-phrase-templates
//   personal-level: users-admin/{userId}/dot-phrase-templates
export const DOT_PHRASE_TEMPLATES = 'dot-phrase-templates'
// Append-only audit log — one doc per expansion event
export const DOT_PHRASE_EXPANSION_LOG = 'dot-phrase-expansion-log'
